module.exports = __webpack_public_path__ + "static/media/ValeVeiculos.37e7740f.png";